import type { ReactNode } from "react";

export type BadgeKind = "neutral" | "brand" | "success" | "live" | "warning";

const STYLES: Record<BadgeKind, React.CSSProperties> = {
  live:    { background: "var(--fg-danger)", color: "#fff" },
  brand:   { background: "var(--brand-orange-soft)", color: "var(--brand-orange-hover)" },
  success: { background: "rgba(30,122,90,0.14)", color: "#1E7A5A" },
  warning: { background: "rgba(255,184,0,0.18)", color: "#8A5A00" },
  neutral: { background: "var(--bg-secondary)", color: "var(--fg2)" },
};

export function Badge({ kind = "neutral", children }: { kind?: BadgeKind; children: ReactNode }) {
  return (
    <span
      style={{
        fontFamily: "var(--font-body)",
        fontSize: 11,
        fontWeight: 600,
        padding: "3px 9px",
        borderRadius: 999,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        whiteSpace: "nowrap",
        ...STYLES[kind],
      }}
    >
      {children}
    </span>
  );
}
